import { render, staticRenderFns } from "./EnterNewTrade.vue?vue&type=template&id=4953d3b7&scoped=true&"
import script from "./EnterNewTrade.vue?vue&type=script&lang=js&"
export * from "./EnterNewTrade.vue?vue&type=script&lang=js&"
import style0 from "./EnterNewTrade.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EnterNewTrade.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./EnterNewTrade.vue?vue&type=style&index=2&id=4953d3b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4953d3b7",
  null
  
)

export default component.exports